<template>
  <div>

    <div class="bg-gray-900 py-1">
      <div class="px-3 py-2">Affichage des likes</div>
      <div class="flex justify-between pt-2 pb-4 mr-2">
        <div
          @click="setLikesDisplay('number')"
          class="flex flex-col w-1/3 items-center cursor-pointer">
          <div class="flex items-center pb-1">
            <div class="w-10 h-4 text-xs font-medium text-center text-gray-900 rounded-full" :class="[ likesDisplay === 'number' ? 'bg-white' : 'bg-gray-600']">Nbr</div>
          </div>
          <div class="text-center text-base" :class="[ likesDisplay === 'number' ? 'text-white' : 'text-gray-600']">
            Nombre
          </div>
        </div>
        <div
          @click="setLikesDisplay('connected')"
          class="flex flex-col w-1/3 items-center cursor-pointer">
          <div class="flex items-center pb-1">
            <div class="w-10 h-4 text-xs font-medium text-center text-gray-900 rounded-full" :class="[ likesDisplay === 'connected' ? 'bg-white' : 'bg-gray-600']">% C</div>
          </div>
          <div class="text-center text-base" :class="[ likesDisplay === 'connected' ? 'text-white' : 'text-gray-600']">
            % de connectés
          </div>
        </div>
        <div
          @click="setLikesDisplay('attendees')"
          class="flex flex-col w-1/3 items-center cursor-pointer">
          <div class="flex items-center pb-1">
            <div class="w-10 h-4 text-xs font-medium text-center text-gray-900 rounded-full" :class="[ likesDisplay === 'attendees' ? 'bg-white' : 'bg-gray-600']">% P</div>
          </div>
          <div class="text-center text-base" :class="[ likesDisplay === 'attendees' ? 'text-white' : 'text-gray-600']">
            % de participants
          </div>
        </div>
      </div>
    </div>

    <div class="bg-gray-700 py-1">
      <div class="px-3 py-2">Affichage des tops</div>
      <div class="flex justify-between pt-2 pb-4">
        <div
          @click="setTops('10%')"
          class="flex flex-col w-1/3 items-center cursor-pointer">
          <div class="flex items-center pb-2">
            <img
              v-if="tops === '10%'"
              class="w-8 h-8 cursor-pointer"
              src="../../assets/icons/topsOn.svg"
              alt="Top 10% on"
            />
            <img
              v-else
              class="w-8 h-8 cursor-pointer"
              src="../../assets/icons/topsOff.svg"
              alt="Top 10% off"
            />
          </div>
          <div class="text-base" :class="[ tops === '10%' ? 'text-white' : 'text-gray-600']">
            Top 10%
          </div>
        </div>
        <div
          @click="setTops('5')"
          class="flex flex-col w-1/3 items-center cursor-pointer">
          <div class="flex items-center pb-2">
            <img
              v-if="tops === '5'"
              class="w-8 h-8 cursor-pointer"
              src="../../assets/icons/topsOn.svg"
              alt="Top 5 on"
            />
            <img
              v-else
              class="w-8 h-8 cursor-pointer"
              src="../../assets/icons/topsOff.svg"
              alt="Top 5 off"
            />
          </div>
          <div class="text-base" :class="[ tops === '5' ? 'text-white' : 'text-gray-600']">
            Top 5
          </div>
        </div>
        <div
          @click="setTops('10')"
          class="flex flex-col w-1/3 items-center cursor-pointer">
          <div class="flex items-center pb-2">
            <img
              v-if="tops === '10'"
              class="w-8 h-8 cursor-pointer"
              src="../../assets/icons/topsOn.svg"
              alt="Top 10 on"
            />
            <img
              v-else
              class="w-8 h-8 cursor-pointer"
              src="../../assets/icons/topsOff.svg"
              alt="Top 10 off"
            />
          </div>
          <div class="text-base" :class="[ tops === '10' ? 'text-white' : 'text-gray-600']">
            Top 10
          </div>
        </div>
      </div>
    </div>

    <div class="bg-gray-900 px-3 py-1 rounded-t-none rounded-lg">
      <div class="py-2">Affichage des identifiants</div>
      <div class="flex justify-around pt-2 pb-4">
        <div
          @click="toggleIdsDisplay('number')"
          class="flex flex-col w-1/3 items-center cursor-pointer">
          <div class="flex items-center pb-1">
            <div class="w-10 h-4 text-xs text-center text-gray-900 rounded-full" :class="[ idsDisplay['number'] ? 'bg-white' : 'bg-gray-600']">N°</div>
          </div>
          <div class="text-center text-base" :class="[ idsDisplay['number'] ? 'text-white' : 'text-gray-600']">
            N° de contribution
          </div>
        </div>
        <div
          @click="toggleIdsDisplay('label')"
          class="flex flex-col w-1/3 items-center cursor-pointer">
          <div class="flex items-center pb-1">
            <div class="w-10 h-4 text-xs text-center text-gray-900 rounded-full" :class="[ idsDisplay['label'] ? 'bg-white' : 'bg-gray-600']">Label</div>
          </div>
          <div class="text-center text-base" :class="[ idsDisplay['label'] ? 'text-white' : 'text-gray-600']">
            Nom du label
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex'

export default {
  computed: {
    ...mapState({
      likesDisplay: state => state.grid.likesDisplay,
      tops: state => state.grid.tops,
      idsDisplay: state => state.grid.idsDisplay,
    }),
  },
  methods: {
    ...mapMutations('grid', [
      'setLikesDisplay',
      'setTops',
      'toggleIdsDisplay',
    ]),
  }
}
</script>

<style>

</style>
